<script>
import NoneReportTraderSearchModal from "./NoneReportTraderSearchModal.vue";
import NoneReportTraderAddModal from "./NoneReportTraderAddModal.vue"
import {mapActions} from "vuex";
/**
 * 報告不要業者データ補完モーダル
 */
export default {
  name: "NoneReportTraderComplementModal",
  components: {
    NoneReportTraderSearchModal,
    NoneReportTraderAddModal,
  },
  props: {
    dialog: {
      type: Boolean,
      default: () => false
    },
    /**
     * 一覧で選択されたマニフェストID
     */
    selectableIds: {
      type: Array,
      default: () => []
    },
    searchedAt: {
      type: Number,
      default: () => null,
    },
  },
  watch: {
    dialog(val) {
      this.transferManifests = [];
      if (val) {
        this.transferManifestSearch();
      }
    }
  },
  data () {
    return {
      noneReportTraderSearch: false,
      noneReportTraderAdd: false,
      tableHeader: [
        { text: 'マニフェスト\r\n区間', value: 'manifest_no', sortable: false, width: "10%" },
        { text: '報告不要業者\r\n住所', value: 'jwnet_trader', sortable: false, width: "16%" },
        { text: '報告不要業者事業場\r\n住所', value: 'jwnet_location', sortable: false, width: "16%" },
        { text: 'DXE事業者コード', value: 'dxe_trader_code', sortable: false, width: "11%" },
        { text: 'DXE業者\r\nDXE事業者住所', value: 'dxe_trader', sortable: false, width: "16%" },
        { text: 'DXE事業場\r\nDXE事業場住所', value: 'dxe_location', sortable: false, width: "16%" },
        { text: "", value: "actions", sortable: false, align: "end", width: "15%" }
      ],
      transferManifests: [],
      selectableItem: null,
      selectableId: null,
      selectableType: null,
      selectableSection: null,
    }
  },
  methods: {
    ...mapActions("DriverTransferNoneReportTraderComplement", {
      fetchTransferManifest: "index",
    }),
    /**
     * 選択ボタン クリックイベント
     * 報告不要業者の選択モーダルを表示する.
     */
    selectButtonClickEvent (item) {
      this.selectableItem = item;
      this.noneReportTraderSearch = true;
    },
    /**
     * 新規登録ボタン クリックイベント
     * 報告不要業者の新規登録モーダルを表示する.
     */
    addButtonClickEvent (item) {
      this.selectableId = item.jwnet_manifest_id;
      this.selectableType = item.vendor_type;
      this.selectableSection = item.section;
      this.noneReportTraderAdd = true;
    },
    /**
     * 閉じるボタン クリックイベント
     * 閉じることを呼び出しもとに伝達
     */
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    transferManifestSearch () {
      this.fetchTransferManifest({ params: { jwnet_manifest_ids: this.selectableIds.join(',') } }).then((content) => {
        this.transferManifests = content.transfer_manifest_transports
      })
    },
    /**
     * モーダルからコールバック
     * 本モーダルから立ち上げたモーダルを閉じる
     */
    closeModalCallback () {
      this.noneReportTraderSearch = false;
      this.noneReportTraderAdd = false;
    },
    /**
     * 各モーダルにて登録後のコールバック処理
     * 本モーダル一覧の再検索、呼び出し元一覧の再検索を行い、選択・新規のモーダルを閉じる
     */
     noneReportTraderSearchCallback () {
      this.$emit("registerCallback");
      this.transferManifestSearch();
      this.closeModalCallback();
    },

    vendorName (section, type) {
      if (type === "disposer") {
        return "処分業者";
      } else {
        return `区間${section}${type === 'transporter' ? '収運業者' : '運搬先'}`
      }
    }
  }
}
</script>

<template>
  <div>
    <v-dialog
      :value="dialog"
      scrollable
      width="1500"
      @click:outside="closeButtonClickEvent"
      @close="closeButtonClickEvent"
      @keydown.esc="closeButtonClickEvent"
    >
      <v-card>
        <v-toolbar
          color="primary"
          dark
          flat
        >
          <v-toolbar-title>
            報告不要業者データ補完
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              icon
              dark
              @click="closeButtonClickEvent"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-title class="primary--text">
          報告不要業者
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col>
              <v-data-table
                :headers="tableHeader"
                :items="transferManifests"
                :items-per-page="-1"
                hide-default-footer
                disable-sort
              >
                <template v-slot:[`item.manifest_no`]="{ item }">
                  <div><small>{{ item.manifest_no }}</small></div>
                  <div><small>{{ vendorName(item.section, item.vendor_type) }}</small></div>
                </template>
                <template v-slot:[`item.jwnet_trader`]="{ item }">
                  <div
                    class="text-ellipsis text-sm-caption"
                    :title="item.jwnet_name"
                    style="width: 180px;"
                  >{{ item.jwnet_name }}</div>
                  <div
                    class="text-ellipsis text-sm-caption"
                    :title="item.jwnet_address"
                    style="width: 180px;"
                  >{{ item.jwnet_address }}</div>
                </template>
                <template v-slot:[`item.jwnet_location`]="{ item }">
                  <div
                    class="text-ellipsis text-sm-caption"
                    :title="item.jwnet_location_name"
                    style="width: 180px;"
                  >{{ item.jwnet_location_name }}</div>
                  <div
                    class="text-ellipsis text-sm-caption"
                    :title="item.jwnet_location_address"
                    style="width: 180px;"
                  >{{ item.jwnet_location_address }}</div>
                </template>
                <template v-slot:[`item.dxe_trader_code`]="{ item }">
                  <div><small>{{ item.dxe_trader_code }}</small></div>
                  <div>
                    <v-chip
                      :title="item.dxe_trader_id ? 'マスタ紐付け済' : '紐付け未設定'"
                      label
                      x-small
                      :color="item.dxe_trader_id ? 'info' : 'error'"
                    >
                      {{ item.dxe_trader_id ? 'マスタ紐付け済' : '紐付け未設定' }}
                    </v-chip>
                  </div>
                </template>
                <template v-slot:[`item.dxe_trader`]="{ item }">
                  <div
                    class="text-ellipsis text-sm-caption"
                    :title="item.dxe_trader_name"
                    style="width: 180px;"
                  >{{ item.dxe_trader_name }}</div>
                  <div
                    class="text-ellipsis text-sm-caption"
                    :title="item.dxe_trader_address"
                    style="width: 180px;"
                  >{{ item.dxe_trader_address }}</div>
                </template>
                <template v-slot:[`item.dxe_location`]="{ item }">
                  <div
                    class="text-ellipsis text-sm-caption"
                    :title="item.dxe_location_name"
                    style="width: 180px;"
                  >{{ item.dxe_location_name }}</div>
                  <div
                    class="text-ellipsis text-sm-caption"
                    :title="item.dxe_location_address"
                    style="width: 180px;"
                  >{{ item.dxe_location_address }}</div>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn color="primary" small @click="selectButtonClickEvent(item)">紐付け</v-btn>&emsp;
                  <v-btn color="primary" small @click="addButtonClickEvent(item)">新規追加</v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn @click="closeButtonClickEvent">
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <none-report-trader-search-modal
      :dialog="noneReportTraderSearch"
      :target-item="selectableItem"
      :target-section="selectableSection"
      :target-type="selectableType"
      :target-selectable-ids="selectableIds"
      :searched-at="searchedAt"
      @closeCallback="closeModalCallback"
      @registerCallback="noneReportTraderSearchCallback"
    />
    <none-report-trader-add-modal
      :dialog="noneReportTraderAdd"
      :copy-source-id="selectableId"
      :target-section="selectableSection"
      :target-type="selectableType"
      :target-selectable-ids="selectableIds"
      :searched-at="searchedAt"
      @closeCallback="closeModalCallback"
      @registerCallback="noneReportTraderSearchCallback"
    />
  </div>
</template>

<style scoped lang="scss">

</style>
